var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.384616 0.838679L0 0.838679C0 0.614294 0.083087 0.398731 0.233264 0.239782C0.532701 -0.0765458 1.01156 -0.0802755 1.3158 0.230873L5.00016 4.00394L8.68447 0.230922C8.98829 -0.0803188 9.46732 -0.0765866 9.76703 0.240031C10.0811 0.572428 10.077 1.11963 9.75823 1.44621L5.53666 5.76954C5.2361 6.07686 4.76422 6.07686 4.46343 5.76931L0.242262 1.44639C0.0866919 1.28726 0 1.06768 0 0.838679L0.384616 0.838679Z",
    fill: "#77928B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatDownArrow);
export default __webpack_public_path__ + "static/media/chat-down-arrow.b0b735d99e2f8e38172ec4b602b0ff34.svg";
export { ForwardRef as ReactComponent };